import { gql } from 'src/__generated__'

export default gql(`
  mutation updateUser($data: UpdateUserInput!) {
    updateUser(data: $data) {
      id
    }
  }
`)
